__turbopack_context__.v({
  "className": "geistsans_81192321-module__VVprxa__className",
  "variable": "geistsans_81192321-module__VVprxa__variable",
});
